import { createContext } from "react";

import type { StateService } from "@uirouter/core";

export interface LinkContextValue {
    linkFn: StateService["href"];
}

export const LinkContext = createContext<LinkContextValue | null>(null);
LinkContext.displayName = "LinkContext";
